// src/components/common/WarningMessage.jsx
import React from "react";

/**
 * WarningMessage displays a styled warning banner if a non-empty `message` is provided.
 * Useful for form validation errors, system alerts, or user guidance.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.message - The warning message to display. If falsy, nothing is rendered.
 * @returns {JSX.Element|null} A styled warning message or null if no message is given
 */
function WarningMessage({ message }) {
  if (!message) return null;

  return (
    <div className="mt-2 text-center font-bold text-red-700 bg-red-100 p-2 rounded border border-red-400">
      {message}
    </div>
  );
}

export default WarningMessage;